module.exports = __webpack_public_path__ + "img/pescoco.35e852a9.png";